module.exports = __webpack_public_path__ + "img/sh-logo.1c0862d2.png";